import { Link } from "react-router-dom";

export default function BookCover({ book, size = "md" }) {
  const sizes = {
    sm: "w-32",
    md: "w-44 md:w-52",
    lg: "w-56 md:w-72",
  };

  const hasRealCover = !!book.cover_image && /^https?:/.test(book.cover_image);

  return (
    <Link
      to={`/book/${book.slug}`}
      className="block group"
      data-testid={`book-cover-${book.slug}`}
    >
      <div className={`${sizes[size]} mx-auto relative`}>
        <div
          className="relative aspect-[2/3] overflow-hidden transition-all duration-500 group-hover:-translate-y-1.5"
          style={{
            boxShadow:
              "0 1px 0 rgba(255,255,255,0.08) inset, -4px 0 0 rgba(0,0,0,0.25), 12px 18px 36px rgba(14,35,64,0.35)",
            background: "#0E2340",
          }}
        >
          {hasRealCover ? (
            <img
              src={book.cover_image}
              alt={`${book.title} by ${book.author} - Book Cover`}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
          ) : (
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center">
              <div className="text-[9px] tracking-[0.3em] uppercase text-gold/90 mb-3">1123</div>
              <div className="font-serif text-xl md:text-2xl leading-tight text-ivory">{book.title}</div>
              <div className="mt-3 inline-block border-t border-gold/60 pt-2 text-[10px] uppercase tracking-[0.25em] text-ivory/80">
                {book.author}
              </div>
            </div>
          )}
          <div className="absolute left-2 top-3 bottom-3 w-[2px] opacity-30"
            style={{ background: "repeating-linear-gradient(to bottom, #D4B06A 0 6px, transparent 6px 12px)" }} />

          {book.coming_soon && (
            <div className="absolute top-3 right-3 bg-gold text-navy text-[9px] tracking-[0.22em] uppercase font-semibold px-2.5 py-1"
              data-testid={`coming-soon-badge-${book.slug}`}>
              Coming Soon
            </div>
          )}
        </div>
      </div>
      <div className="text-center mt-5">
        <div className="font-serif text-lg text-navy group-hover:text-gold transition-colors">{book.title}</div>
        <div className="overline mt-1">{book.coming_soon ? "Forthcoming" : book.category}</div>
      </div>
    </Link>
  );
}
